import RangeInput from "./RangeInput";

export default RangeInput;